<template>
    <span class="text-primary" v-if="mostrarBtn">
        <i
            class="fa fa-info-circle fa-lg icon-button mr-1"
            title="Detalhar Requisição"
            @click.stop="detalharRequisicao()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        detalharRequisicao() {
            if (this.$route.name === 'FornecedoresContratos_Comprometimentos') {
                this.$router.push({
                    name: 'FornecedoresContratos_RequisicaoDetalhar',
                    params: {
                        idRequisicao: this.comprometimento.idRequisicao
                    }
                })
            } else {
                this.$router.push({
                    name: 'FornecedorContratos_RequisicaoDetalhar',
                    params: {
                        idRequisicao: this.comprometimento.idRequisicao
                    }
                })
            }
        }
    },

    computed: {
        mostrarBtn() {
            return this.comprometimento.idRequisicao
        }
    }
}
</script>
